import { get } from "./fetch";

export const getCallScriptTemplate = (serviceID) => {
  return get(`/api/manager/callscript/${serviceID}`, false);
};
